import type { CornerRadiusType } from '../../types';

export const getBorderRadius = (
  cornerRadius: CornerRadiusType,
  { circular, rounded }: Record<Exclude<CornerRadiusType, 'square'>, number>
) => {
  if (cornerRadius === 'square') {
    return 0;
  }

  return cornerRadius === 'circular' ? circular : rounded;
};
